/**
 * Small helpers around the login state kept in localStorage.
 *
 * Keys: token (JWT for the admin API), role (role *name* returned by /auth/login,
 * e.g. "admin" or "Super admin"), userName (display name).
 */
export const ROLE_SUPER_ADMIN = "Super admin";
export const ROLE_ADMIN = "admin";

export const getToken = () => localStorage.getItem("token");
export const getRole = () => localStorage.getItem("role") || "";
export const getUserName = () => localStorage.getItem("userName") || "Admin";

export const isLoggedIn = () => Boolean(getToken());
export const isSuperAdmin = () => getRole() === ROLE_SUPER_ADMIN;
export const isAdmin = () => [ROLE_ADMIN, ROLE_SUPER_ADMIN].includes(getRole());

export const getInitials = () => {
	const parts = getUserName().trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) return "A";
	const first = parts[0].charAt(0);
	const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
	return `${first}${last}`.toUpperCase();
};

export const saveLogin = (data) => {
	localStorage.setItem("token", data.access_token);
	localStorage.setItem("role", data.role || "");
	const user = data.data || {};
	const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
	localStorage.setItem("userName", name || user.username || user.email || "Admin");
};

export const clearLogin = () => {
	localStorage.removeItem("token");
	localStorage.removeItem("role");
	localStorage.removeItem("userName");
};

/**
 * "user" (contacts) or "event" mode. Pages that clearly belong to one mode set it;
 * shared pages (Results, Fire extinguisher, Users) keep the last mode the admin was in.
 */
export const modeFromPath = (pathname) => {
	let mode = null;
	if (pathname.startsWith("/events/fireExtStats")) {
		mode = null; // shared page
	} else if (pathname.startsWith("/events") || pathname.startsWith("/event-mode")) {
		mode = "event";
	} else if (pathname.startsWith("/users") || pathname.startsWith("/start-experience")) {
		mode = "user";
	}
	if (mode) {
		sessionStorage.setItem("lcdsMode", mode);
		return mode;
	}
	return sessionStorage.getItem("lcdsMode") || "user";
};
